import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider from "../components/Slider/CardSlider";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import RoiCTA from "../components/CTA/RoiCTA";
import SolutionCard from "../components/Card/SolutionCard";
import Page from "../layout/Page";

const Solutions = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="AI Dashcam Solutions & Fleet Safety – Shoora Telematics for Fleet Management"
      description="Discover Shoora’s AI-powered Dashcam solutions that improve fleet safety, reduce risks, and provide real-time alerts and video retrieval. Explore our modular telematics solutions for smarter fleet management."
      keywords=""
      structuredData={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Shoora AI Dashcam Solutions for Fleet Safety",
        description:
          "Shoora offers AI-powered dashcam solutions for fleets to reduce risks, optimize safety, and provide real-time alerts and video retrieval for improved fleet management.",
        url: "https://www.shoora.com/solutions",
        mainEntityOfPage: "True",
        publisher: {
          "@type": "Organization",
          name: "Shoora",
          logo: "https://www.shoora.com/images/logo.png",
        },
        image: "https://www.shoora.com/images/hero/solutions.webp",
      }}
    >
      <div className="about-hero w-100" style={{ height: "100vh" }}>
        <img
          src="images/hero/solutions.webp"
          alt=""
          className="w-100"
          style={{ objectFit: "cover", height: "100vh" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 px-5">
            <p className="fs-1 text-light mb-5"></p>
            <h1 className="text-accent fw-bold mb-4">
              Intelligent AI Dashcam video solutions
            </h1>
            <p className="fs-5 text-white mb-5">
              Our AI Dashcams utilize artificial intelligence for real time
              detection of distracted driving and road hazards to help optimize
              fleet safety.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-light rounded-5">
                See Plans & Pricing
              </button>
              <Link className="ms-3 btn btn-link text-white fw-bold text-decoration-none">
                Get a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <RoiCTA /> */}

      <div className="about-section section-gradient-animation section">
        <div className="about-content">
          <h1 className="content-scale">
            Shoora offers your fleet all the benefits of a modular{" "}
            <i>telematics solution.</i>
          </h1>
          <p>
            The power and simplicity of a single platform gives your business
            efficiency gains that may exceed expectations.
          </p>
          <p>
            The Shoora platform enables a true connected ecosystem for the
            mobile workforce. Built on open, web-based standards with
            enterprise-grade APIs, it allows growing fleets to easily scale and
            configure how they use their telematics software.
          </p>
        </div>
      </div>

      <CardContainer
        heading="Solutions at Shoora"
        desc="Get to know us through our associates and the impact we make together."
      >
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          desc="Improve safety and protect your fleet with AI-driven risk detection and instant video retrieval."
          imgsrc="/images/banners/cabin-vision.png"
          link="/solutions/cabin-vision"
          customHeading='<h3>
                                Cab<span class="text-warning">In</span>
                                <span class="fw-light">Vision</span>
                                <sup
                                    class="fs-6 fw-bold"
                                >
                                    TM
                                </sup>
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          descriptionColor="#fff"
          desc="Boost safety and secure your fleet with AI-driven risk detection and quick video retrieval."
          imgsrc="/images/banners/cabin-alerts.png"
          link="/solutions/cabin-alerts"
          customHeading='<h3 class="text-white">
                                Cab<span class="text-warning">In</span>
                                <span class="fw-light">Alerts</span>
                                <sup
                                    class="fs-6 fw-bold"
                                >
                                    TM
                                </sup>
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#000"
          descriptionColor="#fff"
          desc="Stay aware of operations—anytime, anywhere. Receivein-app alerts for critical events."
          imgsrc="/images/bg/fs1.jpeg"
          link="/solutions/fleet-sense"
          customHeading='<h3 class="text-white">
                                Fleet<span class="text-accent">Sense</span>
                                
                                <sup
                                    class="fs-6 fw-bold"
                                >
                                    TM
                                </sup>
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          desc="Improve safety and protect your fleet with AI-driven risk detection and instant video retrieval."
          imgsrc="/images/banners/road-sense-1.png"
          link="/solutions/road-sense"
          customHeading='<h3>
                                <span class="text-accent">Road</span>
                                <span class="fw-light">Sense</span>
                                <sup
                                    class="fs-6 fw-bold"
                                >
                                    TM
                                </sup>
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          linkText="Learn More"
          desc="A highly trained back-office team complements ourSaaS platform."
          imgsrc="https://images.pexels.com/photos/7709235/pexels-photo-7709235.jpeg"
          link="/solutions/shoora-life-savers"
          customHeading='<h3 class="">
                                <span class="text-warning">Shoora Life Savers</span>
                                
                                <sup
                                    class="fs-6 fw-light"
                                >
                                    TM
                                </sup>
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          desc="Highly customizable e-modules to train drivers for safety."
          imgsrc="https://images.pexels.com/photos/2896454/pexels-photo-2896454.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          link="/solutions/happy-driver-programme"
          customHeading='<h3>
                                Happy Driver 
                                <span class="fw-light">Programme</span>
                              
                            </h3>'
        />
        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          desc="Safety Initiative, top talents, excellence."
          imgsrc="https://images.pexels.com/photos/5410923/pexels-photo-5410923.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          link="/solutions/marut-insights"
          customHeading='<h3>
                                 <span class="text-warning">Marut</span>
                                <span class="fw-light">Insights</span>
                               
                            </h3>'
        />

        <SolutionCard
          bgColor="#f4f4f4"
          type="img"
          headingColor="#0d004a"
          desc="A groundbreaking innovation in school safety, utilising geofences to notify when a vehicle enters, exits, or stays within a designated area beyond a set timeframe."
          imgsrc="https://images.pexels.com/photos/6440089/pexels-photo-6440089.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          link="/solutions/connected-school-bus"
          customHeading='<h3>
                                 <span class="text-accent">Connected</span>
                                <span class="fw-light">SchoolBus</span>
                               
                            </h3>'
        />
        <SolutionCard
          bgColor="#fad323"
          type="img"
          headingColor="#0d004a"
          //   grayscale={true}
          desc=" Reach out to our sales team today!"
          imgsrc="/images/bg/expert.png"
          customHeading="<h3>
                                 Curious about our solutions? 
                               
                            </h3>"
          linkText="Talk to expert"
          link="#"
        />
      </CardContainer>

      <div className="resources-section">
        <div className="container">
          <CardSlider title={"Discover Our Resources"} />
        </div>
      </div>
    </Page>
  );
};

export default Solutions;
